export enum LanguagesCode {
  en = 'en',
  pt = 'pt',
  fr = 'fr',
}
